import axios from "axios";


export function lookup(dictionaryName, token) {
    return axios.get(`/dictionary/${dictionaryName}/?token=${token}`, );
}